import { Outlet } from 'react-router-dom';
import { useUnifiedAuth } from '@/contexts/UnifiedAuthContext';
import { UnifiedSidebar } from './UnifiedSidebar';
import { RoleBadge } from './RoleBadge';

export function UnifiedLayout() {
  const { user } = useUnifiedAuth();

  return (
    <div className="flex min-h-screen bg-black">
      <UnifiedSidebar />

      <div className="flex-1 flex flex-col min-h-screen">
        {/* Top bar */}
        <header className="h-14 border-b border-white/10 bg-[#111] flex items-center justify-between px-6">
          <div className="flex items-center gap-3">
            <h1 className="text-white font-semibold text-sm lg:text-base">
              {user?.displayName || 'Nexus'}
            </h1>
            <div className="flex gap-1.5">
              {user?.roles.map(role => (
                <RoleBadge key={role} role={role} />
              ))}
            </div>
          </div>

          <div className="flex items-center gap-2">
            {user?.email && (
              <span className="text-gray-500 text-xs hidden sm:block">{user.email}</span>
            )}
          </div>
        </header>

        {/* Main content */}
        <main className="flex-1 overflow-y-auto p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
